<script lang="ts" setup>
import { i18n } from '@/i18n';
import { onMounted, ref, watch } from 'vue';

// props
const props = withDefaults(
  defineProps<{
    labelText?: string;
    isChecked?: boolean;
  }>(),
  {
    labelText: '',
    isChecked: false,
  }
);

// emits
const emits = defineEmits<{
  (e: 'change-status', isChecked: boolean): void;
}>();

//変数
const t = i18n.t;
const isChecked = ref(false);
const id = ref('');
// イベント
onMounted(() => {
  isChecked.value = props.isChecked;
  id.value = generateUniqueId();
});

watch(
  () => props.isChecked,
  () => {
    isChecked.value = props.isChecked;
  }
);

//関数
const isShowLabel = (): boolean => {
  return !!props.labelText;
};

// forタグ用：inputタグのユニークなidを生成する
const generateUniqueId = (): string => {
  return Math.random().toString(36).slice(-8);
};
</script>

<template>
  <div>
    <input :id="id" v-model="isChecked" type="checkbox" class="checkbox-content" @change="emits('change-status', isChecked)" />
    <label v-if="isShowLabel()" :for="id">{{ props.labelText }}</label>
  </div>
</template>

<style lang="scss" scoped>
.checkbox-content {
  width: 16px;
  height: 16px;
  border-radius: 1px;
  border-color: $gray30;
  vertical-align: middle;
  box-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
}
</style>
